import './fixed';
import './language';
import './images';
import './image-viewer';
import './map';
import './menu';
import './mode-switch';



/** WEBPACK FOOTER **
 ** ./src/app.js
 **/